import { PureComponent, type ReactElement } from "react";

import { LoadingSpinner } from "widgets";

import { type RawAttributeDefault, type SampleType } from "../../graphql.js";
import { default as AddSampleTypeDialog, type IAddSampleTypeDialogProps } from "./AddSampleTypeDialog.js";

export interface IModifySampleTypeDialogProps extends IAddSampleTypeDialogProps {
  fetchFullSampleTypeWithAttributeDefaults: (
    sampleTypeId: number,
  ) => Promise<{ sampleType: SampleType; attributeDefaults: RawAttributeDefault[] }>;
}

interface IModifyParentTypeDialogState {
  isLoadingSampleType?: boolean;
  sampleType?: SampleType;
  attributeDefaults?: RawAttributeDefault[];
}

// component that takes the responsibiltiy of loading all the extended properties and attributes of the parent type to be edited
class ModifySampleTypeDialog extends PureComponent<IModifySampleTypeDialogProps, IModifyParentTypeDialogState> {
  constructor(props) {
    super(props);

    this.state = {
      isLoadingSampleType: true,
      sampleType: null,
      attributeDefaults: null,
    };
  }

  componentDidMount() {
    this.props
      .fetchFullSampleTypeWithAttributeDefaults(this.props.sampleType.id)
      .then((result: { sampleType: SampleType; attributeDefaults: RawAttributeDefault[] }) => {
        this.setState({
          sampleType: result.sampleType,
          attributeDefaults: result.attributeDefaults,
          isLoadingSampleType: false,
        });
      });
  }

  render(): ReactElement {
    return this.state.isLoadingSampleType ? (
      <LoadingSpinner inCenter />
    ) : (
      <AddSampleTypeDialog
        {...this.props}
        sampleType={this.state.sampleType}
        attributeDefaults={this.state.attributeDefaults}
      />
    );
  }
}

export default ModifySampleTypeDialog;
